import { onMounted } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import PausasService from '@/services/modules/PausasService'
import usePausaStore from '@/store/pausas'
import useUserStore from '@/store/user'

/*
 * usePausaStore é persistido no localStorage e nunca era confrontado com o backend: se a pausa
 * real fosse encerrada por outro caminho (logout pelo gestor, nova sessão, varredura de sessão
 * ociosa), a tela continuava mostrando um timer rodando para uma pausa que não existe mais, e o
 * agente só descobria ao tentar finalizar e receber "não há nenhum registro ativo".
 *
 * Roda uma vez no onMounted do App.vue, como o useTokenValidation: se o localStorage acha que o
 * agente está em pausa, confirma com GET pausas/situacao-atual antes de deixar o resto da tela
 * (AppBarUserMenu, LayoutContentVerticalNav) decidir se bloqueia a navegação com base nesse estado.
 */
export default function usePausaValidation() {
  const pausaStore = usePausaStore()
  const { isLoggedIn } = storeToRefs(useUserStore())

  function limparPausaEncerrada() {
    clearInterval(pausaStore.timerInterval)
    pausaStore.$reset()
  }

  async function validarSituacaoPausaAtualAsync() {
    if (!isLoggedIn.value) return
    if (!pausaStore.id) return

    let situacaoAtual

    try {
      situacaoAtual = await PausasService.getSituacaoAtual()
    } catch {
      // Falha de rede não pode apagar o estado local sem certeza de que a pausa de fato acabou
      return
    }

    if (!situacaoAtual.emPausa) limparPausaEncerrada()
  }

  onMounted(validarSituacaoPausaAtualAsync)
}
